import { useAppSelector } from 'hooks/reduxHooks'
import { useMemo } from 'react'
import { isBundledCarHireEnabled } from 'selectors/carHireSelectors'

interface Filters {
  pickUpLocationId?: string
  dropOffLocationId?: string
  pickUpDate?: string
  dropOffDate?: string
  pickUpTime?: string
  dropOffTime?: string
  driversAgeCategory?: App.CarHireDriverAgeCategory
  driversAge?: number
  isPickUpAtAirport?: boolean
  pickUpSearchType?: App.CarHireSearchTypes
  dropOffSearchType?: App.CarHireSearchTypes
  bundledOrderId?: string
}

function useCarHireOfferListFilters(filters: Filters) {
  const bundledCarHireEnabled = useAppSelector(state => isBundledCarHireEnabled(state))
  const finalFilters = useMemo((): App.CarHireOfferListFilters => {
    return {
      pickUpLocationId: filters.pickUpLocationId,
      dropOffLocationId: filters.dropOffLocationId,
      pickUpDate: filters.pickUpDate,
      dropOffDate: filters.dropOffDate,
      pickUpTime: filters.pickUpTime,
      dropOffTime: filters.dropOffTime,
      driversAgeCategory: filters.driversAgeCategory,
      driversAge: filters.driversAge,
      isPickUpAtAirport: filters.isPickUpAtAirport,
      pickUpSearchType: filters.pickUpSearchType,
      dropOffSearchType: filters.dropOffSearchType,
      ...(bundledCarHireEnabled && {
        bundledOrderId: filters.bundledOrderId,
      }),
    }
  }, [filters, bundledCarHireEnabled])

  return finalFilters
}

export default useCarHireOfferListFilters
